import React, { lazy, Suspense, useEffect } from "react";
import Loader from "../../components/Loader";

function Index() {
  const Header = React.lazy(() => import("../../layout/Header"));
  const Footer = React.lazy(() => import("../../layout/Footer"));
  const Video = React.lazy(() => import("../../components/Video"));
  const Warriors = React.lazy(() => import("../../components/Warriors"));
  const TeamBasedMoba = React.lazy(() => import("../../components/TeamBasedMoba"));
  const FlagshipGame = React.lazy(() => import("../../components/FlagshipGame"));
  const Roadmap = React.lazy(() => import("../../components/Roadmap"));
  const Partners = React.lazy(() => import("../../components/Partners"));

  return (
    <>
      <Suspense fallback={
        <Loader />}>
        <Header />
        <Video />
        <Warriors />
        <TeamBasedMoba />
        <FlagshipGame />
        <Roadmap /> 
        <Partners />
        <Footer />
      </Suspense>
    </>
  );
}

export default Index;
